import { useMutation } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'
import { useInvalidateAfterFeatureChange } from 'features/customers/hooks/useInvalidateAfterFeatureChange'
import type { FeatureEdits } from 'features/customers/utils/featureEdits'

import { useAddNotification } from 'hooks/useAddNotification'
import { post } from 'utils/http'

export const useCustomerFeaturesModify = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const invalidate = useInvalidateAfterFeatureChange()

  // A query param, not the body: the server diffs the body key by key, so anything extra in there
  // would be read as a feature.
  const modifyFeatures = ({ payload, note }: { payload: FeatureEdits; note?: string }) =>
    post(`/management/customers/${customerId}/features`, payload, { query: note ? { note } : undefined })

  return useMutation({
    mutationFn: modifyFeatures,
    onSuccess: async () => {
      await invalidate()

      addNotification('Features updated successfully', 'success')
    },
    onError: () => {
      addNotification('Failed to update features', 'error')
    },
  })
}
